export default function LabelIcon(props: Icon) {
  const { height, width } = props;
  return (
    <svg
      aria-hidden="true"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height : 20}
      height={height ? height : width ? width : 20}
      viewBox="0 -960 960 960"
    >
      <path
        fill="currentColor"
        d="M577.652-96.348Q551.304-70 513-70t-64.652-26.348l-352-352q-12.674-12.674-20.011-29.587T69-514v-286q0-37.544 26.728-64.272Q122.456-891 160-891h286q19.152 0 36.065 7.337 16.913 7.337 29.587 20.011l352 352.761Q890-484.544 890-446.62t-26.348 64.272l-286 286ZM513.239-160l286-286L446-800H160v286l353.239 354ZM260-640q25 0 42.5-17.5T320-700q0-25-17.5-42.5T260-760q-25 0-42.5 17.5T200-700q0 25 17.5 42.5T260-640ZM160-800Z"
      />
    </svg>
  );
}
